import 'slick-carousel/slick/slick';

function initSlider(id) {
    $('#' + id).slick({
        infinite: false,
        useTransform: false,
        dots: false,
        speed: 400,
        slidesToShow: 3,
        slidesToScroll: 1,
        nextArrow: '<button type="button" class="slick-next" aria-label="Neste"><svg width="12" height="24" viewBox="0 0 12 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.251051 23.7296C-0.0836838 23.3692 -0.0836839 22.7847 0.251051 22.4242L9.93067 12L0.25105 1.57579C-0.0836848 1.21531 -0.0836848 0.630848 0.25105 0.270363C0.585785 -0.0901222 1.1285 -0.0901223 1.46323 0.270363L11.7489 11.3473C12.0837 11.7078 12.0837 12.2922 11.7489 12.6527L1.46323 23.7296C1.1285 24.0901 0.585786 24.0901 0.251051 23.7296Z" fill="#002F44"/></svg></button>',
        prevArrow: '<button type="button" class="slick-prev" aria-label="Forrige"><svg width="12" height="24" viewBox="0 0 12 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.7489 0.270363C12.0837 0.630847 12.0837 1.21531 11.7489 1.57579L2.06932 12L11.7489 22.4242C12.0837 22.7847 12.0837 23.3692 11.7489 23.7296C11.4142 24.0901 10.8715 24.0901 10.5368 23.7296L0.25105 12.6527C-0.0836855 12.2922 -0.0836854 11.7078 0.25105 11.3473L10.5368 0.270363C10.8715 -0.0901211 11.4142 -0.090121 11.7489 0.270363Z" fill="#002F44"/></svg></button>',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });
};
window.initSlider = initSlider;